'use client';
import { useEffect, useOptimistic, useTransition } from 'react';
import {
  StylishAccordionButton,
  StylishAccordionPanel,
} from 'src/components/shared/components/stylish-disclosure';

import { eventTracker } from '@/lib/service-workers';

import Accordion from '@/components/@base/accordion';
import Group from '@/components/@base/input/@shared/group';
import Label from '@/components/@base/input/@shared/label';
import CheckBox from '@/components/@base/input/check-box';
import List, { ListItem } from '@/components/@base/list';
import { Text } from '@/components/@base/typography';
import Props from '@/components/app/archive/components/filter/@shared/items/category-filters/multilayer-filter-list/type';
import { FILTER_KEYS } from '@/components/app/archive/helpers';
import { useFilterParams } from '@/components/app/archive/helpers/hooks';
import { useGetProfile } from '@/components/layout/services/hooks';

import { DATA_CY_CHECK_BOX_ITEM } from '@/constant/cypress';

export default function MultilayerFilterList({ items, initialFilters }: Props) {
  const { profile } = useGetProfile();
  const [filters, setFilters] = useOptimistic(initialFilters[FILTER_KEYS.CATEGORY] || []);
  let [isPending, startTransition] = useTransition();
  const { updateParams,resetParams } = useFilterParams({ searchParams: initialFilters });

  const menuEventHandler = (title) => {
    eventTracker(profile?.mobile, 'category_click', new Date().toISOString(), {
      transcript: title,
    });
  };

  useEffect(() => {
    if(resetParams){
      setFilters([])
    }
  }, [resetParams]);
  const handleChange = (key: string, value: boolean, title: string) => {
    menuEventHandler(title);
    let categories = filters;
    if (value) {
      categories = [...categories, key];
    } else {
      categories = categories.filter((item) => item !== key);
    }

    startTransition(() => {
      setFilters(categories);
      updateParams(FILTER_KEYS.CATEGORY, categories);
    });
  };
  return (
    <List data-pending={isPending ? '' : undefined}>
      {items?.map((item) => (
        <ListItem key={item.id} className='my-2 text-[#5B5C60] first:mt-0 last:mb-0'>
          {item.children && item.children.length > 0 ? (
            <Accordion>
              <StylishAccordionButton>
                {() => (
                  <Group className='flex items-center'>
                    <CheckBox
                      as='div'
                      data-cy={DATA_CY_CHECK_BOX_ITEM}
                      onChange={(checked) => handleChange(item.id, checked, item.title)}
                      checked={filters.includes(item.id)}
                      className='h-4 w-4'
                    />
                    <Label className='mr-4 w-full'>
                      <Text className='ml-4 line-clamp-1'>{item.title}</Text>
                    </Label>
                  </Group>
                )}
              </StylishAccordionButton>
              <StylishAccordionPanel className='my-5 bg-[#F9FAFC] text-right shadow-none'>
                <MultilayerFilterList items={item.children} initialFilters={initialFilters} />
              </StylishAccordionPanel>
            </Accordion>
          ) : (
            <Group className='flex items-center'>
              <CheckBox
                onChange={(checked) => handleChange(item.id, checked, item.title)}
                checked={filters.includes(item.id)}
                className='h-4 w-4'
              />
              <Label className='mr-4 w-full'>
                <Text className='ml-4 line-clamp-1'>{item.title}</Text>
              </Label>
            </Group>
          )}
        </ListItem>
      ))}
    </List>
  );
}
